let REACT_APP_BASE_API_URL = window && window._env_ ? window._env_.REACT_APP_BASE_API_URL : null;

export const Env = {
    API_URL: REACT_APP_BASE_API_URL || process.env.REACT_APP_BASE_API_URL,
}